<app-page-header title="Home" active_item="Carteira (Cripto)" titleLink="/reports"  ></app-page-header>
<div class="loading-wallet" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.cryptoWallets' | translate}}</h5>
<form [formGroup]="wallet">
<div class="row">
  <div class="col-12">
    <div class="card rounded-10 shadow" *ngIf="!isInsert">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="card-title mb-0">{{ 'common.wallets' | translate}}</div>
        <button type="button" class="our-button btn btn-pill btn-primary float-end" (click)="openInsert()"><i class="fe fe-plus"></i>{{ 'common.newWallet' | translate}}</button>
      </div>
      <div class="card-body">
        <div class="scrollable-layout">
          <div class="table-responsive our-table">
            <table class="table table-striped text-nowrap mb-0">
              <thead class="border-top">
                <tr>
                  <th scope="col" class="text-capitalize">{{ 'common.walletName' | translate}}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.hash' | translate}}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.network' | translate}}</th>
                  <th scope="col" class="text-capitalize">{{ 'common.currency' | translate}}</th>
                  <th class="align-middle text-center text-capitalize" scope="col" >{{ 'common.enabled' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom" *ngFor="let wallet of wallets">
                  <td><span>{{wallet.description}}</span></td>
                  <td><span>{{wallet.hash}}</span></td>
                  <td><span>{{wallet.network}}</span></td>
                  <td><span>{{wallet.symbol}}</span></td>
                  <td class="align-middle text-center">
                    <label class="custom-switch">
                      <input type="checkbox" class="custom-switch-input" [checked]="wallet.enable" (click)="showConfirmEnableDisable(modalConfirmEnable, wallet)">
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                </tr>
                <tr *ngIf="wallets.length == 0">
                  <td colspan="8">{{ 'common.noData' | translate}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      
      </div>
    </div>
    <div class="card rounded-10 shadow"*ngIf="isInsert">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.addWallet' | translate}}</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="slSymbols" class="form-label">{{ 'common.currency' | translate}} <span class="text-danger">*</span></label>
              <select id="slSymbols" [formControl]="wallet.controls.symbol" class="form-select"
                      [ngClass]="{'is-invalid state-invalid': wallet.controls.symbol.invalid && isSubmitted}">
                <option value=""></option>
                <option *ngFor="let symbol of symbols" value="{{symbol.id}}">
                  {{symbol.name}}
              </select>
              <div class="invalid-feedback">{{ 'common.currencyRequiredMessage' | translate}}</div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDescricao" class="form-label">{{ 'common.description' | translate}} <span class="text-danger">*</span></label>
              <input [formControl]="wallet.controls.descricao" class="form-control" type="text" id="txtDescricao"
                     [ngClass]="{'is-invalid state-invalid': wallet.controls.descricao.invalid && isSubmitted}">
              <div class="invalid-feedback">{{ 'common.descriptionRequiredMessage' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="slRede" class="form-label">{{ 'common.network' | translate}} <span class="text-danger">*</span></label>
              <select id="slRede" [formControl]="wallet.controls.rede" class="form-select"
                      [ngClass]="{'is-invalid state-invalid': wallet.controls.rede.invalid && isSubmitted}">
                <option *ngFor="let rede of redes" value="{{rede.name}}">
                  {{rede.name}}
              </select>
              <div class="invalid-feedback">{{ 'common.networkRequiredMessage' | translate}}</div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtHash" class="form-label">{{ 'common.hash' | translate}} <span class="text-danger">*</span></label>
              <div class="input-icon-container">
                  <input [formControl]="wallet.controls.hash"
                        class="form-control"
                        type="text"
                        id="txtHash"
                        [ngClass]="{'is-invalid state-invalid': wallet.controls.hash.invalid && isSubmitted}">
                  <i (click)="paste()" class="fe fe-copy input-icon"></i>
                  <div class="invalid-feedback">{{ 'common.hashRequiredMessage' | translate}}</div>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="custom-switch">
                <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input" [formControl]="wallet.controls.terms">
                <span class="custom-switch-indicator"></span>
                <span class="custom-switch-description">{{ 'common.responsibilityCheck' | translate}}</span>
              </label>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-pill btn-primary float-start" (click)="return()"><i class="fe fe-arrow-left"></i>{{ 'common.back' | translate}}</button>
        <button type="button" class="btn btn-pill btn-primary float-end" (click)="add()"><i class="fe fe-plus"></i>{{ 'common.add' | translate}}</button>
      </div>
    </div>
  </div>
</div>
</form>
<ng-template #modalConfirmEnable let-modal>
  <div class="modal-content" style="padding: 0 !important;">
    <div class="modal-header">
      <h5 class="modal-title">{{!selectedWallet.enable ? 'Habilitar' : 'Desabilitar' }} carteira?</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); loadWallets();"></button>
    </div>
    <div class="modal-body">
      <p>Este processo irá {{!selectedWallet.enable ? 'habilitar' : 'desabilitar' }} a carteira selecionada.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close('Close click'); loadWallets();">Cancelar</button>
      <button class="btn btn-{{!selectedWallet.enable ? 'primary' : 'danger'}}" type="button" (click)="enableDisableWallet()">{{!selectedWallet.enable ? 'Habilitar' : 'Desabilitar' }}</button>
    </div>
  </div>
</ng-template>
